export const SCHEMA_VERSIONS = {
  SESSION_EVENT: 2,
  PLAYER_EVENT: 1,
  SNAPSHOT: 1,
} as const;

export type SchemaVersion = (typeof SCHEMA_VERSIONS)[keyof typeof SCHEMA_VERSIONS];

export interface VersionedSchema<T> {
  version: SchemaVersion;
  schema: T;
}
